import { FC } from 'react'

import styled from 'styled-components'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Loader } from '@mantine/core'

import { Tool } from 'src/Redux/api/toolsApi.ts'
import { ToolItem } from 'src/Components/ToolItem'
import { TableLoading } from 'src/Components/TableLoading'
import { NoDataMessage } from 'src/Components/NoDataMessage'
import { Pagination } from 'src/Helpers/types.ts'

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const LoaderWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 16px;
`

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  min-height: 0;
`

type TransportTableProps = {
  tools?: Array<Tool>
  isLoading: boolean
} & Pagination

export const ToolsTable: FC<TransportTableProps> = ({
  tools,
  isLoading,
  onLoadMore,
  hasNextPage,
}) => {
  if (isLoading) {
    return (
      <ListWrapper>
        <TableLoading />
      </ListWrapper>
    )
  }

  if (tools?.length === 0) {
    return (
      <ListWrapper>
        <NoDataMessage />
      </ListWrapper>
    )
  }

  return (
    <ContentContainer>
      <ListWrapper id='scrollableDiv'>
        <InfiniteScroll
          scrollableTarget={'scrollableDiv'}
          dataLength={tools?.length || 0}
          next={onLoadMore}
          hasMore={Boolean(hasNextPage)}
          loader={
            <LoaderWrapper>
              <Loader color='blue' />
            </LoaderWrapper>
          }
        >
          <ItemsContainer>
            {tools?.map((tool) => <ToolItem tool={tool} key={tool.id} />)}
          </ItemsContainer>
        </InfiniteScroll>
      </ListWrapper>
    </ContentContainer>
  )
}
